<template>
  <admin-wrapper
    title-translation-path="admin.HYDRANTS_INSPECTIONS"
    :inputs="inputs"
    :moduleEnabler="moduleEnabler"
    @change="editSingleSettingHandler"
    :is-form-fetched="isFormFetched"
    @save="saveCard"
  >
    <template #hydrantsInspectionsFeatureCard.input>
      <draggable-lists-manage-card
        left-title="admin.featureCardInspection"
        :layer-id="hydrantsInspectionsLayerId"
        @update:hasAnyRequiredOnRightSide="hasAnyRequiredOnRightSide = $event"
        :has-edit-attributes="true"
      >
      </draggable-lists-manage-card>
    </template>
    <template #hydrantsLayerId.input="{ dataType }">
      <v-row no-gutters>
        <v-col cols="4">
          <data-input
            :items="hydrantsAvailableLayers"
            itemText="name"
            itemValue="id"
            :data-type="dataType"
            v-model="editingHydrantsLayerId"
            @change="handleEditHydrantsLayerId"
          />
        </v-col>
      </v-row>
    </template>
  </admin-wrapper>
</template>

<script>
import { call, get } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';
import DataInput from '@/components/DataInput';
import DraggableListsManageCard from '@/components/DraggableListsManageCard';

export default {
  name: 'HydrantsSettings',
  components: {
    AdminWrapper,
    DataInput,
    DraggableListsManageCard,
  },
  data: () => ({
    isFormFetched: false,
    editingHydrantsLayerId: null,
  }),
  computed: {
    currentLayerSchema: get('layers/currentLayerSchema'),
    hydrantsAvailableLayers: get('hydrants/hydrantsAvailableLayers'),
    hydrantsInspectionsDataSourceName: get('admin/modulesMapping@hydrants_inspections.inspections_datasource_name'),
    hydrantsInspectionsLayerId: get('admin/modulesMapping@hydrants_inspections.inspections_layer_id'),
    hydrantsLayerId: get('hydrants/hydrantsLayerId'),
    isModuleEnabled: get('admin/settingsValues@hydrants_inspections_module_enabled'),
    dataSourcesNames() {
      return this.$_objectToArray(this.dataSources).map(dataSource => dataSource.name);
    },
    moduleEnabler() {
      return {
        name: 'hydrants_inspections_module_enabled',
        translationPath: 'admin.HYDRANTS_INSPECTIONS',
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.$i18n.t('admin.HYDRANTS_INSPECTIONS') }),
      };
    },
    inputs() {
      return [
        {
          name: 'hydrantsLayerId',
          translationPath: 'admin.hydrantsLayerId',
          subtitle: 'admin.hydrantsLayerIdSubtitle',
          align: 'start',
          dataType: {
            name: 'select',
          },
        },
        {
          name: 'hydrants_inspections_module_next_inspection_threshold',
          translationPath: 'admin.hydrantsInspectionsModuleIextInspectioTthreshold',
          subtitle: 'admin.hydrantsInspectionsModuleIextInspectioTthresholdSubtitle',
          align: 'start',
          dataType: {
            name: 'integer',
          },
          minValue: 1,
        },
        {
          name: 'hydrants_inspections_module_next_inspection_soon_threshold',
          translationPath: 'admin.hydrantsInspectionsNextInspectionWarning',
          align: 'start',
          dataType: {
            name: 'integer',
          },
          subtitle: 'admin.hydrantsInspectionsNextInspectionWarningSubtitle',
        },
        {
          name: 'hydrantsInspectionsFeatureCard',
          translationPath: 'admin.featureCardInspection',
          isCustom: true,
          subtitle: this.$i18n.t('admin.setFeatureCard', { type: this.$i18n.t('admin.inspectionType') }),
          align: 'start',
        },
      ];
    },
  },
  methods: {
    editHydrantsLayerId: call('hydrants/editHydrantsLayerId'),
    editLayer: call('layers/editLayer'),
    editSingleSetting: call('admin/editSingleSetting'),
    getDataSourceForm: call('layers/getDataSourceForm'),
    getFeaturesLayer: call('layers/getFeaturesLayer'),
    getHydrantsAvailableLayers: call('hydrants/getHydrantsAvailableLayers'),
    getHydrantsLayerId: call('hydrants/getHydrantsLayerId'),
    getLayerMetadata: call('layers/getLayerMetadata'),
    getModulesMapping: call('admin/getModulesMapping'),
    editSingleSettingHandler(value, name) {
      if (name === 'hydrants_inspections_module_next_inspection_soon_threshold') {
        this.editSingleSetting({
          key: name,
          body: {
            value,
          },
        });
      } else {
        return;
      }
    },
    async handleEditHydrantsLayerId(value) {
      try {
        const payload = {
          layer_id: value,
        };
        await this.editHydrantsLayerId(payload);
      } catch {
        this.editingHydrantsLayerId = JSON.parse(JSON.stringify(this.hydrantsLayerId));
      }
    },
    async init() {
      await this.getModulesMapping();
      await Promise.all([
        this.getDataSourceForm(this.hydrantsInspectionsDataSourceName),
        this.getFeaturesLayer(this.hydrantsInspectionsLayerId),
        this.getLayerMetadata({ dataSource: this.hydrantsInspectionsDataSourceName }),
        this.getHydrantsAvailableLayers(),
        this.getHydrantsLayerId(),
      ]);
      this.editingHydrantsLayerId = JSON.parse(JSON.stringify(this.hydrantsLayerId));
      this.isFormFetched = true;
    },
    async saveCard() {
      await this.editLayer({
        layer_type: 'features_layers',
        layer_id: this.hydrantsInspectionsLayerId,
        body: {
          form_schema: {
            elements: this.currentLayerSchema,
          },
        },
      });
    },
  },
  watch: {
    isModuleEnabled(nV) {
      if (nV) {
        this.isFormFetched = false;
        this.init();
      }
    },
  },
  created() {
    if (this.isModuleEnabled) {
      this.init();
    } else {
      this.isFormFetched = true;
    }
  },
};
</script>
